@if (environment.debugMode) {
  <!--    <div class="" style="border: 1px solid red">-->
  <div class="mt-3">
    <h2>DEBUG data</h2>
    <ng-content></ng-content>
  </div>
}
